<template>
	<div>
		<div class="d-flex align-items-center mb-3">
			<div>
				<h1 class="page-header mb-0"><i class="fa fa-charging-station"></i> Berendezés napló</h1>
			</div>
		</div>
		<panel title="Berendezések amelyeken van lakat">
			<Loading title="Berendezések betöltése" v-if="!logs"></Loading>
			<div v-else>
				<vue-good-table :columns="columns" :rows="logs" :lineNumbers="false" mode="remote"
					@on-page-change="onPageChange" @on-sort-change="onSortChange" @on-column-filter="onColumnFilter"
					@on-per-page-change="onPerPageChange" :totalRows="totalRecords" :isLoading.sync="isLoading"
					:search-options="{ enabled: false, placeholder: 'Keresés...' }" :pagination-options="{
						enabled: true,
						position: 'bottom',
						firstLabel: 'Első Lap',
						lastLabel: 'Utolsó Lap',
						nextLabel: 'következő',
						prevLabel: 'előző',
						rowsPerPageLabel: 'Sor oldalanként',
						ofLabel: '/',
						dropdownAllowAll: false,
						allLabel: 'Összes',
						infoFn: (params) => `első sorszám: ${params.firstRecordOnPage}`,
					}">
					<template slot="table-row" slot-scope="props">
						<span v-if="props.column.field == 'created_at'">
							{{ props.row.created_at | moment('YYYY-MM-DD, HH:mm') }}
						</span>
						<span v-else-if="props.column.field == 'task_id'">
							<router-link :to="'/tasks/'+props.row.task_id+'/edit'" class="btn btn-dark btn-xs" title="munkafolyamathoz">{{ props.row.task_id }} <i class="fa fa-paper-plane"></i></router-link>
						</span>
						<span v-else-if="props.column.field == 'lock_id'">
							<span class="fa-stack" v-if="props.row.lock_color && props.row.lock_color != 3">
								<i class="fa-solid fa-lock fa-stack-2x"
									:class="{ 'text-primary': props.row.lock_color == 1, 'text-black-strict': props.row.lock_color == 4 }"></i>
								<i class="fa-solid fa-stack-1x text-white fs-10px mt-5px">{{ props.row.lock_id }}</i>
							</span>
							<span v-else-if="(props.row.lock_color == 3)">
								<span class="fa-stack" v-for="(red_lock, id) in JSON.parse(props.row.lock_id)" :key="id">
									<i class="fa-solid fa-lock fa-stack-2x text-red"></i>
									<i class="fa-solid fa-stack-1x text-white fs-10px mt-5px">{{ red_lock.lock_name }}</i>
								</span>
							</span>
							<span v-else>
								<strong>
									{{ props.row.lock_id }} -számú szekrény
								</strong>
								<i class="fa-solid fa-key fa-2x text-primary"></i>
							</span>
						</span>
						<span v-else>
							{{ props.formattedRow[props.column.field] }}
						</span>
					</template>
				</vue-good-table>
			</div>
		</panel>
	</div>
</template>

<script>
import Loading from '../../components/Loading';
import Log from "../../apis/Log";
export default {
	components: {
		Loading
	},
	data() {
		return {
			logs: false,
			isLoading: true,
			totalRecords: 0,
			serverParams: {
				columnFilters: {
				},
				sort:
				{
					type: 'desc',
					field: 'created_at',
				},
				page: 1,
				perPage: 10
			},
			columns: [
				{
					label: 'Mf. száma',
					field: 'task_id',
					filterOptions: {
						enabled: true,
						placeholder: 'Keresés',
					},
					tdClass: 'fw-bold text-center',
					thClass: 'fw-bold text-center',
				},
				{
					label: 'Munkafolyamat megnevezése',
					field: 'task_name',
					filterOptions: {
						enabled: true,
						placeholder: 'Keresés',
					},
					width: '20%',
				},
				{
					label: 'Pozíció/Szekrény szám',
					field: 'position_number',
					filterOptions: {
						enabled: true,
						placeholder: 'Keresés',
					}
				},
				{
					label: 'Pozíció/Szekrény név',
					field: 'position_name',
					filterOptions: {
						enabled: true,
						placeholder: 'Keresés',
					}
				},
				{
					label: 'Lakat/kulcs',
					field: 'lock_id',
					filterOptions: {
						enabled: true,
						placeholder: 'Keresés',
						filterFn: this.lockColumnFilter
					}
				},
				{
					label: 'Kiadta',
					field: 'given_by',
					filterOptions: {
						enabled: true,
						placeholder: 'Keresés',
					}
				},
				{
					label: 'Felhasználó',
					field: 'user_name',
					filterOptions: {
						enabled: true,
						placeholder: 'Keresés',
					}
				},
				{
					label: 'Időpont',
					field: 'created_at',
					filterOptions: {
						enabled: true,
						placeholder: 'Keresés',
					}
				},
			],
			errors: [],
		}
	},
	created() {
		this.loadItems();
	},
	methods: {
		updateParams(newProps) {
			this.serverParams = Object.assign({}, this.serverParams, newProps);
		},

		onPageChange(params) {
			this.updateParams({ page: params.currentPage });
			this.loadItems();
		},

		onPerPageChange(params) {
			this.updateParams({ perPage: params.currentPerPage });
			this.loadItems();
		},

		onSortChange(params) {
			this.updateParams({
				sort: {
					type: params[0].type,
					field: params[0].field,
				},
			});
			this.loadItems();
		},

		onColumnFilter(params) {
			this.updateParams(params);
			this.loadItems();
		},

		// load items is what brings back the rows from server
		loadItems() {
			this.isLoading = true;
			Log.positionLogs(this.serverParams).then(response => {
				this.logs = response.data.data;
				this.totalRecords = response.data.total;
				this.updateParams({
					perPage: response.data.per_page,
					page: response.data.current_page,
				});
			}).finally(() => {
				this.isLoading = false;
			});
		}
	}
}
</script>

<style></style>